export class Occupation {
    constructor(public occupationId: number,
                public occupationName: string)
      { }
  }
